import React, { useState, useEffect } from 'react';
import AsciiDrumEditor from './AsciiDrumEditor';
import { AppManager } from './config/app';
import './index.css';
import { ThemeProvider, useThemeContext } from './context/ThemeProvider';
import { LanguageProvider } from './context/LanguageProvider';
import { devLog } from './utils/devLog';
import type { DrumsetConfig } from './types';

function AppContent(): JSX.Element {
  const [drumsetConfig, setDrumsetConfig] = useState<DrumsetConfig | null>(null);
  const [showDrumsetEditor, setShowDrumsetEditor] = useState<boolean>(false);

  const { getClass } = useThemeContext();

  // 初始化應用
  useEffect(() => {
    AppManager.initialize();
  }, []);

  // 載入鼓組配置
  useEffect(() => {
    const saved = localStorage.getItem('drumsetConfig');
    if (saved) {
      try {
        setDrumsetConfig(JSON.parse(saved) as DrumsetConfig);
      } catch (error) {
        console.error('Error loading drumset config:', error);
      }
    }
  }, []);

  const handleDrumsetUpdate = (config: DrumsetConfig): void => {
    devLog('📡 App received drumset update from AsciiDrumEditor:', config);
    setDrumsetConfig(config);
  };

  const handleToggleDrumsetEditor = (): void => {
    setShowDrumsetEditor(!showDrumsetEditor);
  };

  const handleCloseDrumsetEditor = (): void => {
    setShowDrumsetEditor(false);
  };

  // 應用主題類名到整個應用
  const appClassName = `App min-h-screen transition-colors duration-200 ${getClass('background')} ${getClass('text')}`;

  return (
    <div className={appClassName}>
      <AsciiDrumEditor 
        drumsetConfig={drumsetConfig}
        onToggleDrumsetEditor={handleToggleDrumsetEditor}
        onDrumsetUpdate={handleDrumsetUpdate}
        showDrumsetEditor={showDrumsetEditor}
        onCloseDrumsetEditor={handleCloseDrumsetEditor}
      />
    </div>
  );
}

function App(): JSX.Element {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App; 